export interface NvpParameter {
  Name: string;
  Value: number | number[] | string | null;
  Accuracy: number;
  ChpDataType?: string;
  ElementCount?: number;
  [key: string]: unknown;
}

export const PARAM_GROUPS = [
  {
    label: "Daggerboard Rake",
    params: [
      "DB_Rake_Angle_P_HS2_gain",
      "DB_Rake_Angle_P_HS2_offset",
      "DB_Rake_Angle_S_HS2_gain",
      "DB_Rake_Angle_S_HS2_offset",
    ],
  },
  {
    label: "Rudder Rake",
    params: [
      "Rud_Rake_Angle_HSRW2_P_gain",
      "Rud_Rake_Angle_HSRW2_P_offset",
      "Rud_Rake_Angle_HSRW2_S_gain",
      "Rud_Rake_Angle_HSRW2_S_offset",
    ],
  },
  {
    label: "Daggerboard Cant",
    params: [
      "DB_Cant_Angle_P_HS2_gain",
      "DB_Cant_Angle_P_HS2_offset",
      "DB_Cant_Angle_S_HS2_gain",
      "DB_Cant_Angle_S_HS2_offset",
    ],
  },
  {
    label: "Hull Offsets",
    params: [
      "IC_Hull_Heel_P_offset",
      "IC_Hull_Heel_S_offset",
      "IC_Hull_Pitch_P_offset",
      "IC_Hull_Pitch_S_offset",
    ],
  },
  {
    label: "Lengths",
    params: [
      "Jib_Sheet_Length_x",
      "Jib_Lead_Length_x",
      "DB_Length_P_x",
      "DB_Length_S_x",
    ],
  },
  {
    label: "Rudder Angle",
    params: ["Rudder_Angle_Offset"],
  },
] as const;

export type ParamGroup = (typeof PARAM_GROUPS)[number];

/** Index NVP-style param dumps by Name. */
export function toParamMap(params: ReadonlyArray<Record<string, unknown>>): Map<string, NvpParameter> {
  return new Map(params.map((p) => [p.Name as string, p as unknown as NvpParameter]));
}

const _f32Buf = new Float32Array(1);

/** Narrow a number to IEEE-754 single-precision (F32). */
function toF32(n: number): number {
  _f32Buf[0] = n;
  return _f32Buf[0];
}

function formatNumber(n: number, accuracy: number, chpDataType?: string): string {
  const v = chpDataType === "F32" ? toF32(n) : n;
  return v.toFixed(accuracy);
}

export function valuesMatch(
  a: unknown,
  b: unknown,
  accuracy?: number,
  chpDataType?: string,
): boolean {
  if (accuracy != null) {
    return formatValue(a as NvpParameter["Value"], accuracy, chpDataType)
        === formatValue(b as NvpParameter["Value"], accuracy, chpDataType);
  }
  if (a === b) return true;
  return JSON.stringify(a) === JSON.stringify(b);
}

export function formatValue(
  v: NvpParameter["Value"],
  accuracy: number,
  chpDataType?: string,
): string {
  if (v == null) return "-";
  if (Array.isArray(v)) return v.map((n) => formatNumber(n, accuracy, chpDataType)).join(", ");
  if (typeof v === "number") return formatNumber(v, accuracy, chpDataType);
  return String(v);
}
